import { Injectable, OnDestroy } from '@angular/core';
import { fromEvent, Subscription } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class WakelockService implements OnDestroy {
  private wakeLock: any = null
  private visibilityChangeSubscription: Subscription | null = null;

  constructor() {
    console.log("Requesting Wake Lock");
    
    this.requestWakeLock();
    this.visibilityChangeSubscription = fromEvent(document, 'visibilitychange').subscribe(() => {
      if (document.visibilityState === 'visible') {
        this.requestWakeLock();
      } else {
        this.releaseWakeLock();
      }
    });
  }

  public async requestWakeLock() {
    try {
      if ('wakeLock' in navigator) {
        this.wakeLock = await (navigator as any).wakeLock.request('screen');
        this.wakeLock.addEventListener('release', () => {
          console.log('Wake Lock was released');
        });
        console.log('Wake Lock is active');
      }
    }
    catch (err: any) {
      console.error(`${err.name}, ${err.message}`);
    }
  }
  
  public async releaseWakeLock() {
    if (this.wakeLock) {
      await this.wakeLock.release();
      this.wakeLock = null;
    }
  }

  ngOnDestroy() {
    this.releaseWakeLock();
    if (this.visibilityChangeSubscription) {
      this.visibilityChangeSubscription.unsubscribe();
      this.visibilityChangeSubscription = null;
    }
  }

}
